<template>
    <div>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <!--<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
                        <el-breadcrumb-item>USERS LIST</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
                <el-col :span="8" style="float: right;">
                    <el-input placeholder="Enter search keywords" v-model="queryInfo.query">
                        <el-button slot="append" icon="el-icon-search" @click="seacher"></el-button>
                    </el-input>
                </el-col>

            </el-row>
        </el-card>

        <el-table

                border=""
                :data="tasklist"
                style="width: 100%"
        >

            <el-table-column
                    prop="id"
                    label="ID">
            </el-table-column>

            <el-table-column
                    prop="username"
                    label="Username">
            </el-table-column>
            <el-table-column
                    prop="create_time"
                    label="Registered Time">
            </el-table-column>

            <el-table-column
                    prop="status"
                    :formatter="formatBoolean"
                    label="Status">
            </el-table-column>

            <el-table-column
                    label="Options">
                <template slot-scope="scope">
                    <el-row :gutter="20">
                        <el-col :span="4">


                            <i  v-if="scope.row.status"   class="el-icon-close" @click="status(scope.row.id)"></i>
                            <i v-else class="el-icon-check" title="Disable" @click="status(scope.row.id)"></i>
                        </el-col>
                        <el-col :span="4">
                            <i class="el-icon-delete" title="Delete" @click="deleteit(scope.row.id)"></i>
                        </el-col>
                        <el-col :span="4">
                            <i class="el-icon-edit" title="Edit" @click="editShow(scope.row.id)"></i>
                        </el-col>
                    </el-row>
                </template>

            </el-table-column>
        </el-table>

        <el-card>
            <el-row :gutter="20">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </el-row>
        </el-card>
        <el-dialog
                title="编辑"
                :visible.sync="editVisible" @click="addClose">
            <el-form :model="editForm" :rules="rules" ref="editFormRef">

                <el-form-item prop="id" label="id" hidden>
                    <el-input v-model="editForm.id" ></el-input>
                </el-form-item>
                <el-form-item prop="email" label="email">
                    <el-input v-model="editForm.email" ></el-input>
                </el-form-item>

                <el-form-item prop="phone" label="phone">
                    <el-input v-model="editForm.phone" ></el-input>
                </el-form-item>
                <el-form-item prop="name" label="name">
                    <el-input v-model="editForm.name" ></el-input>
                </el-form-item>
                <el-form-item prop="company" label="company">
                    <el-input v-model="editForm.company" ></el-input>
                </el-form-item>
                <el-form-item prop="country" label="country">
                    <el-input v-model="editForm.country" ></el-input>
                </el-form-item>
                <el-form-item prop="password" label="password">
                    <el-input type="password" v-model="editForm.password" ></el-input>
                </el-form-item>

                <el-form-item v-if="role==='1'" prop="role" label="修改用户类型" >
                    <el-radio-group v-model="editForm.role">
                        <el-radio :label="2">administrator</el-radio>
                        <el-radio :label="3">user</el-radio>
                    </el-radio-group>
                </el-form-item>



            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">Cancel</el-button>
                <el-button type="primary" @click="edit">Submit</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "UserList.vue",

        data(){
            return{
                queryInfo:{
                    query:"",
                    page:1,
                    pagesize:10,
                },
                total:0,
                tasklist:[],
                addVisible:false,
                editVisible:false,
                isdowning:false,
                addForm:{},
                editForm:{},
                temp:"",
                role:"",
                depss:{},
                rules:{

                },

            }

        },

        created() {
            document.title = "USERS LIST - Welcome to BTI Wireless’s RMA Process System";

            this.getTaskList();
        },
        methods:{

            async getTaskList(){
                const result=await this.$http.get("user/list",{params:this.queryInfo});
                if(result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.tasklist=result.data.data.data;
                    this.total=result.data.data.total;
                    this.queryInfo.pagesize=parseInt(result.data.data.per_page);
                    this.queryInfo.page=result.data.data.current_page;

                }
                this.role=localStorage.getItem("role");
            },

            seacher(){
                this.queryInfo.page=1;
                this.getTaskList();
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.getTaskList();
            },
            addClose(){
                this.$refs.addFormRef.resetFields();
                this.editVisible=false;
            },
            handleCurrentChange(newPage){
                this.queryInfo.page=newPage;
                this.getTaskList();
            },

            async getDate(id){
                const result=await this.$http.get("user/info/"+id);
                this.editForm=result.data.data;
            }
            ,
            async editShow(id){
                const result=await this.$http.get("user/info/"+id);
                this.editForm=result.data.data;
                console.log(this.editForm);
                this.editVisible=true;

            },

            edit() {
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }

                    const result=await this.$http.post("user/edit",this.editForm);

                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.editVisible=false;
                        this.getTaskList();
                    }
                });
            },
            async status(id){
                console.log(id);
                const result=await this.$http.get("user/status/"+id);

                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.$message.success(result.data.msg);
                    this.getTaskList();
                }
            },
            async deleteit(id){
                console.log(id);
                const result=await this.$http.get("user/delete/"+id);
                console.log(result);
                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.$message.success(result.data.msg);
                    this.getTaskList();
                }
            },


            formatBoolean: function (row, column) {
                return row.status === 1 ? 'Active' : 'Disabled'
            },

        }
    }
</script>

<style lang="less" scoped>
    .el-table{

    }
    .el-breadcrumb{
        padding-top: 10px;
    }
    .el-card{
        margin-bottom: 5px;
    }
    .el-table{
        margin-bottom: 5px;
    }
    .el-table-column{
        padding-left: 10px;
    }
    .el-form{
        width: 100%;
    }
</style>
